import React,{useState,useEffect} from "react";
/*  import useSelector to fetch data from global  redux store  */

//import KnowledgeCube from "../img/knowledgecube.gif";
import closeIcon from "../icons/close_FILL0_wght200_GRAD-25_opsz40.svg";

import leftOpen from "../icons/fullscreen_FILL0_wght200_GRAD0_opsz40.svg";
//import { useSelector } from "react-redux";
  import { useRouteMatch,Switch, Route } from "react-router-dom";

  
  import { useDispatch,useSelector } from 'react-redux';
  
import Loading from "../Loading/Loading"; 
import { useParams ,useHistory,} from "react-router-dom";


import loadable from '@loadable/component';
import AppSettings from "../Create/CreateApp";
import CreateContent from "../Create/CreateContent";
import CreateCourse from "../Create/CreateCourse";
import CreateProduct from "./CreateProduct/CreateProduct";
import ProductMenuRightCard from "./AppCards/ProductMenuRightCard";
import WebsiteSettings from "../Create/CreateWebsite/Wesbsite";
import AdminCourseBatchesCard from "../Create/Batches/AdminCourseBatchesCard";

// npm i @loadable/component 
let lazyLoad =   <Loading/>;
  ;
    const MyApps = loadable(() => import("./MyApps"), {
      fallback: lazyLoad  });
      const Navber = loadable(() => import("../../Navbar/UserMenu"), {
        fallback: lazyLoad  });

        const MyCourses = loadable(() => import("./MyCourses"), {
            fallback: lazyLoad  });
                
  
 const MyAppsHome = ()=>{
      const {url}=useRouteMatch();
      const [open , setOpen]=useState(false);
   // const userdata = useSelector((state)=>state?.user?.user?.user);
   const dispatch = useDispatch();
    
      const history = useHistory();
      const pathname = window.location.pathname;
   const mainMenuStatus = useSelector((state)=>state?.app?.mainMenuStatus);
 
      const [activeCardOverview, setActiveCardOverview] =useState(false);
                                       const [activeCardScreens, setActiveCardScreens] =useState(false);
                                       const [activeCardElements, setActiveCardElements] =useState(false); 
                                         
                                       const [fixMenuAppRight, closeFixMenuAppRight] =useState(false);   
                                        const [openAppDesignPopUpInn,setopenAppDesignPopUpInn]  = useState(false);
                                      
                                       const rightFixClose =fixMenuAppRight?"-50%":"30px";
                                       const rightFixOpen =fixMenuAppRight?"30px":"-50%";
                                       const fixMenuAppRightHide={width:"70px",right:rightFixOpen,height:"80px"}
                                       const fixMenuAppRightShow={width:"70px",right:rightFixClose}
                                     const [productMenuRightCardPrice, setProductMenuRightCardPrice] = useState(false);
                                      const [activeCardSettings, setActiveCardSettings] =useState(false);
                                                               
                                              const [designContent, openDesignContent] =useState(false);    
                               
  useEffect(() => {
    
    setOpen(false)
     
  }, []);
                       
  useEffect(() => {
      dispatch({type: "routerLocation",payload:pathname  });
   
     
  }, [pathname]);
 
  
  
  const AppToken = useSelector((state)=>state?.app?.app?.AppToken);


    return <>

<div className={`${mainMenuStatus?"outer-all ":"outer-all-small"}  ` } style={{zIndex:"99"}} >
  <div></div>
<div className = {` outer-left ${open?"outer-left-style":"outer-right-style"} `}style={{zIndex:"99"}}   id="outer-left">
  
<div className=""> 
       
      {              open?
              <div className="outer-left-close" style={{marginTop:"-20px"}} onClick={()=>setOpen(false)}><img src={closeIcon} alt="left-close" /></div>
                :
            ""
              }
              
 
<div  style={{"height":"10px"}}>
            
        </div>
       <Navber/>
    </div>
    
    
    </div>
    <div className="outer-right">
        <div className="content-topk">
              <div className="">
                
                {/* {
              open?
             ""   :
            <div className=" outer-left-open" onClick={()=>setOpen(true)}>
                            <img src={leftOpen} alt="left Open"/></div>
              } */}
             </div>
           </div> 

    








           <Switch>
    <Route exact path={`${url}/`}>
    <MyApps/>
    </Route>
    
     <Route path={`${url}/my-apps`}>
    <MyApps/>
      </Route>
   
       
       <Route path={`${url}/${AppToken}/create/manage`}>
       <CreateContent   />
       </Route> 
       <Route path={`${url}/${AppToken}/create`}>
       <CreateProduct   onClickSetOverviewState={()=>{openDesignContent(false);setActiveCardOverview(true);;setProductMenuRightCardPrice(false);setActiveCardElements(false);;setActiveCardSettings(false);}}
         />
      
        
       </Route> 
      
       
       
         <Route path={`${url}/${AppToken}/settings/create-content`}>
           {// other components 
           }
           <CreateContent/>
        
           </Route>
    
           <Route path={`${url}/${AppToken}/settings/`}>
         <AppSettings/>
           </Route>
           <Route path={`${url}/${AppToken}/website/`}>
         <WebsiteSettings/>
           </Route>
      
    
   

     
</Switch>
       
        
       
        

       
     {pathname!=="/apps"&&pathname!==`${url}/${AppToken}/settings`&&pathname!==`${url}/${AppToken}/website`?  <div>
<div  className="fix-menu-product-right-app"  style={fixMenuAppRightHide}>  
<ProductMenuRightCard  activeCard={{}}  icon={9} title ="open" onClickPopup={
          ()=>{closeFixMenuAppRight(false);  }} /></div>
<div  className="fix-menu-product-right-app" style={fixMenuAppRightShow}>  

<ProductMenuRightCard  activeCard={activeCardOverview}  icon={2} title ="Overview" onClickPopup={
          ()=>{ history.push(`/apps/${AppToken}/create/course-name`) ; openDesignContent(false);setActiveCardOverview(true);;setProductMenuRightCardPrice(false);setActiveCardElements(false);;setActiveCardSettings(false);   }} />
  <ProductMenuRightCard  activeCard={productMenuRightCardPrice}  icon={4} title ="Content" onClickPopup={
          ()=>{openDesignContent(false);  history.push(`/apps/${AppToken}/create/content`) ; setActiveCardOverview(false);;setProductMenuRightCardPrice(true);setActiveCardElements(false);;setActiveCardSettings(false);    }} />
<ProductMenuRightCard  activeCard={activeCardElements}  icon={6} title ="Manage" onClickPopup={
          ()=>{ history.push(`/apps/${AppToken}/create/manage`) ; openDesignContent(false);setActiveCardOverview(false);;setProductMenuRightCardPrice(false);setActiveCardElements(true);;setActiveCardSettings(false);  }} />
          <ProductMenuRightCard  activeCard={activeCardSettings}  icon={6} title ="Publish" onClickPopup={
          ()=>{openDesignContent(false);  setActiveCardOverview(false);;setActiveCardScreens(false);setActiveCardElements(false);;setActiveCardSettings(true);  }} />
  {/* <ProductMenuRightCard  activeCard={activeCardElements}  icon={6} title ="Themes" onClickPopup={
          ()=>{openDesignContent(false);setActiveCardOverview(false);;setActiveCardScreens(false);setActiveCardElements(true);;setActiveCardSettings(false);  }} /> */}
 {/* <ProductMenuRightCard  activeCard={activeCardSettings}  icon={7} title ="Settings" onClickPopup={
          ()=>{openDesignContent(false);  setActiveCardOverview(false);;setActiveCardScreens(false);setActiveCardElements(false);;setActiveCardSettings(true);  }} /> */}
  <ProductMenuRightCard  activeCard={{}}  icon={8} title ="close" onClickPopup={
          ()=>{closeFixMenuAppRight(true);  }} />
        
                
                <div className="content-bottom">

        </div>
    </div> </div> :""} </div>
</div>

       
       
   
    </>

}
export default MyAppsHome;
